export const forgotPasswordEN = {
  main: 'Recover password',
  placeholder: 'Enter your email, and we will send you a link to return to your account.',
  send: 'Send'
}
